import { computed, inject, Injectable, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { MailTemplateService, MailTemplateSummary } from '../../../../../../api';
import { QueryKey } from '../../../../../constants/query-key';

interface MailTemplateFilter {
  searchTerm?: string | null;
}

@Injectable()
export class MailTemplateQueryService {
  private readonly mailTemplateService = inject(MailTemplateService);

  filterParams = signal<MailTemplateFilter>({ searchTerm: null });

  mailTemplatesQuery = injectQuery(() => ({
    queryKey: [QueryKey.MAIL_TEMPLATES, this.filterParams()],
    queryFn: () => lastValueFrom(this.mailTemplateService.getMailTemplates(this.filterParams().searchTerm ?? null)),
  }));

  mailTemplates = computed<MailTemplateSummary[]>(() => this.mailTemplatesQuery.data()?.mailTemplates ?? []);
  isLoading = computed(() => this.mailTemplatesQuery.isLoading());

  editingId = signal<number | null>(null);

  private readonly mailTemplateDetailQuery = injectQuery(() => ({
    queryKey: [QueryKey.MAIL_TEMPLATE, this.editingId()],
    queryFn: () => lastValueFrom(this.mailTemplateService.getMailTemplateById(this.editingId()!)),
    enabled: this.editingId() !== null,
  }));

  mailTemplateDetails = computed(() => this.mailTemplateDetailQuery.data()?.mailTemplate ?? null);
}
